import React from 'react';
import capitalize from 'capitalize';
import { displayKey } from './lib/tiles';

export default class GameHeader extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  getLabel() {
    switch (this.props.gameType) {
      case 'geometry':
        return this.props.current ? capitalize(this.props.current) : 'You win!';
      default:
        return this.props.current
          ? this.props.current[displayKey[this.props.gameDisplay] == 0 ? 1 : 0]
          : 'You win!';
    }
  }

  render() {
    const label = this.getLabel();
    const gameType = this.props.gameDisplay;
    return (
      <div className="hidden-picture__header">
        <span className="hidden-picture__instruction">
          Choose the game tile that solves for this {gameType}.
        </span>
        <span className="hidden-picture__flashcard">{label}</span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/game-header.js
 **/